import axios from "axios";

const state = {
    details:[],
    activeDetailId:0,
    activeDetail:{
        "id": 0,
        "image": "",
        "title": "",
        "copy": ""
    },
    startscreen:{
        "image":'',
        "title":'',
        "copy":'',
        "confirm":''
    },
    instructions: {
        "image": '',
        "title": '',
        "copy": '',
        "confirm": ''
    }
}

const getters = {
    activeDetailId:(state) => state.activeDetailId,
    details: (state) => state.details,
    activeDetail: (state) => state.activeDetail,
    startscreen:(state)=> state.startscreen,
    instructions:(state)=>state.instructions
}

const actions = {
    async loadDetails({
        commit
    }) {

        const res = await axios.get('data/content.json');
        try {
            if (res.data.details) {
                commit('setDetails', res.data.details );
            }
            if(res.data.startscreen){
                commit('setStartscreen', res.data.startscreen);
            }
            if (res.data.instructions) {
                commit('setInstructions', res.data.instructions);
            }
        } catch (err) {
            //
            console.log("error loading content details " + err);
        }

    },
    setActiveDetailId({commit},id){
        commit('setActiveDetailId', id);
    }
}

const mutations = {
    setDetails: (state, data) => {
        state.details = data;
    },
    setActiveDetailId: (state,id)=>{
        const d = state.details.find(el => el.id===id);
        if(d){
            state.activeDetail = d;
            state.activeDetailId = id;
        }else{
            if(id<1){
                state.activeDetailId = id;
                state.activeDetail = {
                    "id": 0,
                    "image": "",
                    "title": "",
                    "copy": ""
                };
            }
        }
        
    },
    setStartscreen:(state,data)=>{state.startscreen = data;},
    setInstructions: (state, data) => {
        state.instructions = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}